import * as locationTypes from '../../../../common/redux/actions/types/LocationTypes';

export default function filterIMPCCodesIfExistsInPostalOperators(
  impcCodes,
  postalOperators,
  reportDefinition,
) {
  const filteredIMPCCodes = [];

  if (!reportDefinition || !postalOperators || postalOperators.length === 0) {
    return [...impcCodes];
  }

  const addIfExistsInIMPCCodes = (impcCode) => {
    if (impcCodes.includes(impcCode)) {
      filteredIMPCCodes.push(impcCode);
    }
  };

  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < postalOperators.length; index++) {
    const postalOperator = postalOperators[index];

    addIfExistsInIMPCCodes(postalOperator.value);
    // eslint-disable-next-line
    for (let impcIndex = 0; impcIndex < postalOperator.children.length; impcIndex++) {
      const impc = postalOperator.children[impcIndex];
      if (reportDefinition.locationType === locationTypes.OPERATOR) {
        if (impcCodes.includes(impc.value)) {
          filteredIMPCCodes.push(...postalOperator.children.map(impcChild => impcChild.value));
          break;
        }
      } else {
        addIfExistsInIMPCCodes(impc.value);
      }
    }
  }

  return filteredIMPCCodes;
}
